import { render } from "./EditorialFlairVideo.vue?vue&type=template&id=b6625b76&scoped=true"
import script from "./EditorialFlairVideo.vue?vue&type=script&lang=js"
export * from "./EditorialFlairVideo.vue?vue&type=script&lang=js"

import "./EditorialFlairVideo.vue?vue&type=style&index=0&id=b6625b76&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6625b76"]])

export default __exports__